//@flow
import storage from "redux-persist/lib/storage";
export default {
  whitelist: [],
  blacklist: ["loginPageStore", "chartsStore", "resetPasswordPageStore", "changePasswordPageStore"],
  storage
};